// extracted by mini-css-extract-plugin
module.exports = {"container":"MainContent_container__xdH1b","disabled":"MainContent_disabled__3HRTf"};